<template>
    <b-modal v-if="!loading" id="complaint_form" ref="complaint_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">
        <template v-slot:modal-title>
            {{ !edit ? 'Add New Complaint' : 'Edit Complaint' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus"
                            mode="single"
                            v-model="datepicker.date"
                            @input="'date' in errors ? (delete errors.date) : ''"
                            :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'date' in errors"
                                                 v-text="'date' in errors ? errors.date[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Facilities" class="has-float-label">
                        <template v-slot:label>
                            <span>Facilities <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateFacility" v-model="selected.facility" :options="facilities"
                                  :border-danger="'facility_id' in errors"/>

                        <b-form-invalid-feedback :state="!'facility_id' in errors"
                                                 v-text="'facility_id' in errors ? errors.facility_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Unit" class="has-float-label">
                        <template v-slot:label>
                            <span>Unit <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateUnit" v-model="selected.unit" :options="units"
                                  :border-danger="'unit_id' in errors"/>

                        <b-form-invalid-feedback :state="!'unit_id' in errors"
                                                 v-text="'unit_id' in errors ? errors.unit_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>


            <b-row>
                <b-colxx md="4">
                    <b-form-group label="Complained by" class="has-float-label">
                        <template v-slot:label>
                            <span>Complained by <sup><code>*</code></sup></span>
                        </template>
                        <v-select v-if="!units"/>

                        <v-select v-else @input="updateComplainedBy" v-model="selected.complained_by"
                                  :options="complained_by"
                                  :border-danger="'complained_by' in errors"/>

                        <b-form-invalid-feedback :state="!'complained_by' in errors"
                                                 v-text="'complained_by' in errors ? errors.complained_by[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="8">
                    <div v-if="!selected.complained_by">
                        <b-form-input type="text" placeholder="Complained by" disabled/>
                    </div>

                    <template v-else>
                        <div v-show="form.complained_by === 'Client'">
                            <b-form-group label="Client" class="has-float-label">
                                <template v-slot:label>
                                    <span>Client <sup><code>*</code></sup></span>
                                </template>

                                <v-select ref="vSelectClients" label="client_id" :filterable="false" v-model="selected.client" :options="clients"
                                          @search="fetchClients" @input="updateClient" :border-danger="'client_id' in errors"
                                          :disabled="edit">
                                    <template slot="no-options">
                                        type to search client...
                                    </template>

                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            <div class="d-flex flex-row">
                                                <img class="mr-2" :src="clientImage(option)" :alt="option.data.name"
                                                     style="height: 25px; width: 25px; object-fit: cover"/>
                                                <p class="my-auto">
                                                    {{ option.data.attributes.name + " (SSN: " + option.data.attributes.ssn + ")" }}</p>
                                            </div>
                                        </div>
                                    </template>

                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            <div class="d-flex flex-row">
                                                <img class="mr-2" :src="clientImage(option)" :alt="option.data.name"
                                                     style="height: 16px; width: 16px; object-fit: cover"/>
                                                <span
                                                    class="my-auto">{{ option.data.attributes.name + " (SSN: " + option.data.attributes.ssn + ")" }}</span>
                                            </div>
                                        </div>
                                    </template>

                                    <template slot="spinner" slot-scope="spinner">
                                        <div class="spinner-border text-primary" v-show="spinner"></div>
                                    </template>
                                </v-select>

                                <b-form-invalid-feedback :state="!'client_id' in errors"
                                                         v-text="'client_id' in errors ? errors.client_id[0] : ''"/>
                            </b-form-group>
                        </div>

                        <div v-show="form.complained_by === 'Inspector'">
                            <b-form-group label="Inspector" class="has-float-label">
                                <template v-slot:label>
                                    <span>Inspector <sup><code>*</code></sup></span>
                                </template>

                                <v-select ref="vSelectInspectors" @input="updateInspector" v-model="selected.inspector" :options="inspectors"
                                          :border-danger="'inspector_id' in errors"/>

                                <b-form-invalid-feedback :state="!'inspector_id' in errors"
                                                         v-text="'inspector_id' in errors ? errors.inspector_id[0] : ''"/>
                            </b-form-group>
                        </div>

                        <div v-show="form.complained_by === 'HASA'">
                            <b-form-group label="Name" class="has-float-label">
                                <template v-slot:label>
                                    <span>Name <sup><code>*</code></sup></span>
                                </template>

                                <b-form-input type="text" v-model="form.hasa_name"
                                              @input="'hasa_name' in errors ? (delete errors.hasa_name) : ''"
                                              :class="{'border-danger': 'hasa_name' in errors}"
                                              autocomplete="off" placeholder="Name"/>

                                <b-form-invalid-feedback :state="!'hasa_name' in errors"
                                                         v-text="'hasa_name' in errors ? errors.hasa_name[0] : ''"/>
                            </b-form-group>
                        </div>

                        <div v-show="form.complained_by === 'Other'">
                            <b-form-group label="Name" class="has-float-label">
                                <template v-slot:label>
                                    <span>Name <sup><code>*</code></sup></span>
                                </template>

                                <b-form-input type="text" v-model="form.other_name"
                                              @input="'other_name' in errors ? (delete errors.other_name) : ''"
                                              :class="{'border-danger': 'other_name' in errors}"
                                              autocomplete="off" placeholder="Name"/>

                                <b-form-invalid-feedback :state="!'other_name' in errors"
                                                         v-text="'other_name' in errors ? errors.other_name[0] : ''"/>
                            </b-form-group>
                        </div>
                    </template>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Description" class="has-float-label">
                        <template v-slot:label>
                            <span>Description <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea rows="6" v-model="form.description"
                                         :class="{'border-danger': 'description' in errors}"
                                         @input="'description' in errors ? (delete errors.description) : ''"
                                         autocomplete="off" placeholder="Description"/>

                        <b-form-invalid-feedback :state="!'description' in errors"
                                                 v-text="'description' in errors ? errors.description[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Notes" class="has-float-label">
                        <b-form-textarea rows="6" v-model="form.notes" placeholder="Notes"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('complaint_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitComplaint">Submit</state-button>

            <state-button v-if="edit" variant="primary" :click="updateComplaint">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";
import {mapGetters} from "vuex";
import moment from "moment";
import _ from "lodash";

export default {
    name: "ComplaintFormModal",

    components: {
        StateButton,
    },

    props: [
        'edit'
    ],

    data() {
        return {
            loading: true,
            fetchedComplaint: null,
            selected: {
                facility: [],
                unit: [],
                client: [],
                inspector: [],
                complained_by: null,
            },
            clients: [],
            deleted_contents: [],
            deleted_attachments: [],
            datepicker: {
                date: null,
                cap_due: null,
            },
            complained_by: [
                {label: 'Client', value: 'Client'},
                {label: 'Inspector', value: 'Inspector'},
                {label: 'HASA', value: 'HASA'},
                {label: 'Other', value: 'Other'},
            ],
        }
    },

    computed: {
        ...mapGetters({
            form: 'getComplaintForm',
            errors: 'getComplaintErrors',
            facilities: 'getSelectFacilities',
            units: 'getSelectFacilityUnits',
            inspectors: 'getSelectInspectors',
        }),
    },

    watch: {
        form() {
            if (this.edit) {
                this.selected.facility = this.form.select_facility;
                this.$store.dispatch('fetchSelectFacilityUnits', this.form.facility_id);

                this.datepicker.date = moment(this.form.date).toDate();
            }
        },

        'datepicker.date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.date = null;
            this.form.date = moment(date).format('YYYY-MM-DD');
        },
    },

    mounted() {
        this.getFormData();
    },

    methods: {
        updateComplainedBy(field) {
            if (field) {
                this.selected.client = [];
                this.selected.inspector = [];

                if (field.value === 'Client') {
                    this.form.inspector_id = '';
                    this.form.hasa_name = '';
                    this.form.other_name = '';
                } else if (field.value === 'Inspector') {
                    this.form.client_id = '';
                    this.form.hasa_name = '';
                    this.form.other_name = '';
                } else if (field.value === 'HASA') {
                    this.form.client_id = '';
                    this.form.inspector_id = '';
                    this.form.other_name = '';
                } else if (field.value === 'Other') {
                    this.form.client_id = '';
                    this.form.inspector_id = '';
                    this.form.hasa_name = '';
                }
                if (field) {
                    this.form.complained_by = field.value;
                } else {
                    this.form.complained_by = '';
                }
            }
            'complained_by' in this.errors ? delete this.errors.complained_by : '';
        },

        async getFormData() {
            await this.$store.dispatch('fetchSelectFacilities');
            await this.$store.dispatch('fetchSelectInspectors');

            return this.loading = false;
        },

        updateFacility(field) {
            if (field) {
                this.form.facility_id = field.facility_id;
                this.selected.unit = [];
                this.$store.dispatch('fetchSelectFacilityUnits', field.facility_id);
            } else {
                this.form.facility_id = '';
            }
            'facility_id' in this.errors ? delete this.errors.facility_id : '';
        },

        updateUnit(field) {
            if (field) {
                this.form.unit_id = field.unit_id;
            } else {
                this.form.unit_id = '';
            }
            'unit_id' in this.errors ? delete this.errors.unit_id : '';
        },

        fetchClients: _.debounce(function (search, loading) {
            if (search) {
                axios.get(`/api/hms/search/clients?search=${escape(search)}`)
                    .then(response => {
                        this.clients = response.data.data;
                        loading(false)
                    })
            }
        }, 300),

        updateClient(field) {
            if (field) {
                this.form.client_id = field.client_id;
            } else {
                this.form.client_id = '';
            }

            'client_id' in this.errors ? delete this.errors.client_id : '';
        },

        clientImage(client) {
            if (client.data.attributes.image !== 'Not Assigned') {
                return '/storage/images/clients/' + client.data.attributes.image;
            }

            if ((client.data.attributes.gender).toLowerCase() === 'male') {
                return '/default/gender_male.png';
            } else if ((client.data.attributes.gender).toLowerCase() === 'female') {
                return '/default/gender_female.png';
            } else {
                return '/default/gender_unknown.png';
            }
        },

        updateInspector(field) {
            if (field) {
                this.form.inspector_id = field.user_id;
            } else {
                this.form.inspector_id = '';
            }

            'inspector_id' in this.errors ? delete this.errors.inspector_id : '';
        },

        resetForm() {
            this.$emit('closed');
            this.$store.commit('setComplaintForm');

            this.selected = {
                facility: [],
                unit: [],
                client: [],
                inspector: [],
                complained_by: [],
            };

            this.datepicker = {
                date: null,
            };
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        submitComplaint() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitComplaint', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new complaint!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('complaint_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateComplaint() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateComplaint', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the complaint!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('complaint_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
